import Router from "./route/Index";

const App = () => {
  return (
      <Router />
  );
};
export default App;